<div class="container amplifyBorders">

  <sl-tab-group>
    <sl-tab slot="nav" panel="login">Inloggen</sl-tab>
    <sl-tab #tabCreate slot="nav" panel="create">Profiel Aanmaken</sl-tab>

    <sl-tab-panel name="login">
      <form class="centered-content" data-amplify-form *ngIf="loginForm" [formGroup]="loginForm" (ngSubmit)="onSubmit($event)" >
        <div class="info" *ngIf="!userFound">
          <p><b>Koppel nu je <i><u>e-ducate.me</u></i> profiel aan je <i><u>{{poolName}}</u></i> account.</b></p>
          <p>Vul hieronder je e-ducate.me login gegevens in.</p>
          <b>Heb je nog geen e-ducate.me profiel ?</b>
          <p>Geen probleem, klik dan snel op Profiel Aanmaken.</p>
        </div>
        <div class="warning" *ngIf="destination_pool && !userFound">
          <b>Opgelet: vul dus NIET je {{poolName}} login in !</b>
        </div>
        <div class="success" *ngIf="userFound">
          <b>Uw account bestaat al in ons systeem <br>Uw e-mailadres werd vooraf ingevuld.</b>
          <p>We koppelen nu uw <i><u>{{poolName}}</u></i> account aan <br>uw <i><u>e-ducate.me</u></i> account. <br>Gelieve met uw e-ducate.me gegevens in te loggen.</p>
        </div>
        <div class="amplify-flex amplify-authenticator__column" data-orientation="horizontal">

          <div class="form-group">
            <label class="amplify-label" for="principal">Gebruikersnaam of email</label>
            <input type="text" class="amplify-input" id="principal" formControlName="principal">
            <div *ngIf="loginForm.get('principal')?.errors && loginForm.get('principal')?.dirty" class="error">
              Gebruikersnaam is verplicht en moet geldig zijn.
            </div>
          </div>

          <div class="form-group">
            <label class="amplify-label" for="password">Wachtwoord</label>
            <input type="password" class="amplify-input" id="password" formControlName="password">
            <div *ngIf="loginForm.get('password')?.errors && loginForm.get('password')?.dirty" class="error">
              E-mailadres is verplicht en moet geldig zijn.
            </div>
          </div>
        </div>
        <div class="form-group buttons">
          <button class="amplify-button amplify-button--fullwidth amplify-button--medium amplify-button--primary" type="submit">inloggen</button>
        </div>
      </form>
    </sl-tab-panel>

    <sl-tab-panel name="create">
      <app-add-user [isMapping]="true" (finalizeNewUser)="finalizeMapping($event)"/>
    </sl-tab-panel>
  </sl-tab-group>





  <!--  <form class="centered-content amplifyBorders" data-amplify-form *ngIf="validateForm" [formGroup]="validateForm" (ngSubmit)="onSubmit($event)" >-->

<!--  </form>-->
</div>

